// https://javascript.plainenglish.io/export-react-components-as-images-15168b73b0eb
const saveFile = (blob, fileName) =>
  new Promise((resolve, reject) => {
    try {
      var link = window.document.createElement('a');
      link.href = blob;
      link.download = fileName;
      link.style = 'display:none;';
      (document.body || document.documentElement).appendChild(link);
      if (typeof link.click === 'function') {
        link.click();
      } else {
        link.target = '_blank';
        link.dispatchEvent(
          new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
          })
        );
      }
      URL.revokeObjectURL(link.href);
      link.remove();
      resolve(fileName);
    } catch (error) {
      reject(error);
    }
  });

export default saveFile;
